import * as types from './constants';

// Get Discover Link Categories
export const getDiscoverLinkCategoriesRequest = data => (
  { type: types.GET_DISCOVER_LINK_CATEGORIES_REQUEST, payload: data }
);

export const getDiscoverLinkCategoriesDone = data => (
  { type: types.GET_DISCOVER_LINK_CATEGORIES_DONE, payload: data }
);

export const getDiscoverLinkCategoriesFailed = errors => (
  { type: types.GET_DISCOVER_LINK_CATEGORIES_FAILED, payload: errors }
);

export const getDiscoverLinkCategoriesReset = () => (
  { type: types.GET_DISCOVER_LINK_CATEGORIES_RESET }
);

// Operations

export const discoverLinkCategoriesSetPage = data => (
  { type: types.DISCOVER_LINK_CATEGORIES_SET_PAGE, payload: data }
);
